const state = {
    headersDetails: [
        { text: "TIPO", value: "TIPO" },
        { text: "CALORIAS", value: "CALORIAS" }
    ],
    headersCargos: [
        { text: "TIPO", value: "TIPO" },
        { text: "STATUS", value: "STATUS" },
        { text: "INICIO", value: "INICIO" },
        { text: "FIN", value: "FIN" },
        { text: "MONTO", value: "MONTO" },
        { text: "PRIMER PEDIDO", value: "MONTO" },
        { text: "ULTIMO PEDIDO", value: "MONTO" },
        { text: "CREDITOS", value: "CREDITOS" }
    ],
    headersClaims: [
        { text: "FOTO", value: "FOTO" },
        { text: "NIVEL", value: "NIVEL" },
        { text: "TEXTO", value: "TEXTO" },
        { text: "CATERING", value: "CATERING" },
        { text: "DESCUENTO", value: "DESCUENTO" },
        { text: "FECHA", value: "FECHA" },
        { text: "REGISTRADO", value: "REGISTRADO" },
    ],
    additionals: {
        id: "",
        items: [
            {
                id: null,
                meal_calorie_id: 7,
                meal_type_id: 9,
                meal_additional_id: 1,
                portion: 1,
                credits: 0
            },
            {
                id: null,
                meal_calorie_id: 6,
                meal_additional_id: 2,
                meal_type_id: 9,
                portion: 1,
                credits: 0
            }
        ]
    }
};
const getters = {
    getCredits: state => state.credits,
    getHeadersDetails: state => state.headersDetails,
    getHeadersCargos: state => state.headersCargos,
    getHeadersClaims: state => state.headersClaims,
    getAdditionals: state => state.additionals
};

export default {
    state,
    getters
};
